import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Compact labelled select for admin filter toolbars (matches FilterFieldCheck label height).
 */
export default function FilterFieldSelect({
  id,
  label,
  value,
  onChange,
  options,
  className,
  disabled = false,
}) {
  return (
    <div className={classNames('flex-shrink-0', className)} style={{ minWidth: '13rem' }}>
      <label htmlFor={id} className="form-label d-block">
        {label}
      </label>
      <select
        id={id}
        className="form-select"
        value={value}
        onChange={onChange}
        disabled={disabled}
      >
        {options.map((opt) => (
          <option key={opt.value === '' ? '__empty' : String(opt.value)} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}

FilterFieldSelect.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};
